import { Check } from "lucide-react";
import { BRAND } from "../lib/constants";

const WEDDING = [
  {
    title: "Escalade",
    price: 1000,
    items: ["Red Carpet Service", "Decor Options", "Champagne Service", "Professional Chauffeur"],
  },
  {
    title: "Sprinter Van",
    price: 1300,
    items: ["Red Carpet Service", "Decor Options", "Champagne Service", "Professional Chauffeur"],
  },
];

const PROM = [
  {
    title: "Escalade",
    price: 800,
    items: ["Red Carpet Service", "Decor Options", "Bottled Water", "Professional Chauffeur"],
  },
  {
    title: "Sprinter Van",
    price: 1100,
    items: ["Red Carpet Service", "Decor Options", "Bottled Water", "Professional Chauffeur"],
  },
];

const PackageCard = ({ p, accent }) => (
  <div
    data-testid={`package-card-${p.title.toLowerCase().replace(/\s/g, "-")}`}
    className="bg-[#0A0A0A] border border-zinc-800 p-7 hover:border-[#E50914] transition-all duration-500"
  >
    <div className="flex items-center justify-between">
      <h4 className="font-display text-xl uppercase tracking-tight">{p.title}</h4>
      <span
        className={`text-[10px] tracking-[0.25em] uppercase px-2 py-1 ${accent === "red" ? "bg-[#E50914]/10 text-[#E50914]" : "bg-white/10 text-white"}`}
      >
        5 Hours
      </span>
    </div>
    <div className="mt-5 flex items-baseline gap-2">
      <span className="font-display text-5xl text-[#E50914]">${p.price.toLocaleString()}</span>
    </div>
    <ul className="mt-6 space-y-3">
      {p.items.map((i) => (
        <li key={i} className="flex items-center gap-3 text-sm text-zinc-300">
          <Check className="w-4 h-4 text-[#E50914] flex-shrink-0" strokeWidth={2.5} />
          {i}
        </li>
      ))}
    </ul>
  </div>
);

export const Packages = () => {
  return (
    <section
      id="packages"
      data-testid="packages-section"
      className="relative py-24 md:py-32 border-t border-zinc-900 overflow-hidden"
    >
      <div className="absolute inset-0 opacity-20">
        <img
          src={BRAND.redCarpet}
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black via-black/80 to-black" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-16">
          <div className="text-[10px] tracking-[0.3em] text-[#E50914] uppercase mb-4">
            ⏤ Signature Packages
          </div>
          <h2 className="font-display text-4xl md:text-6xl uppercase tracking-tighter leading-none">
            Built for the <br />
            <span className="text-[#E50914]">Main Event.</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-10">
          {/* WEDDING */}
          <div>
            <div className="flex items-center justify-between mb-6">
              <h3 className="font-display text-2xl uppercase tracking-tight">Wedding Packages</h3>
              <div className="h-px flex-1 bg-zinc-800 mx-6" />
              <span className="text-[10px] tracking-[0.3em] text-zinc-500">01</span>
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              {WEDDING.map((p) => (
                <PackageCard key={p.title} p={p} accent="red" />
              ))}
            </div>
          </div>

          {/* PROM */}
          <div>
            <div className="flex items-center justify-between mb-6">
              <h3 className="font-display text-2xl uppercase tracking-tight">Prom Packages</h3>
              <div className="h-px flex-1 bg-zinc-800 mx-6" />
              <span className="text-[10px] tracking-[0.3em] text-zinc-500">02</span>
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              {PROM.map((p) => (
                <PackageCard key={p.title} p={p} accent="white" />
              ))}
            </div>
          </div>
        </div>

        <p className="mt-10 text-center text-xs text-zinc-500 tracking-[0.2em] uppercase">
          Additional Time · Escalade <span className="text-[#E50914]">$120/hr</span> · Sprinter{" "}
          <span className="text-[#E50914]">$175/hr</span>
        </p>
      </div>
    </section>
  );
};
